/*
 * $Id:$
 * Copyright 2019 Emily36107@outlook.com All rights reserved.
 */
/**
 * RequestError
 *
 * @author Emily Wang
 * @since 2018.01.22
 */
export default class RequestError extends Error {
  /**
   * default constructor
   *
   * @param {string} message - error message
   * @param {string} code - error code
   */
  constructor (message, code) {
    super(message)
    this.code = code || null
  }
};



// WEBPACK FOOTER //
// ./src/api/RequestError.js